module.exports = __webpack_public_path__ + "img/Evaluate Tests gry.af1f06f1.svg";